import { DocumentMapping } from "@/configuration/document-mappings/types";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { getClassificationDisplay } from "@/src/lib/utils/classification";
import { Classification } from "@/src/models/constants/classifications";
export const ENTP_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.REFERRAL]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.REFERRAL,
    displayName: getClassificationDisplay(Classification.REFERRAL, true),
    assignedTo: "VAL Sayiner, Sibel",
    folder: "Referral",
    markAsReviewed: true,
    workflowType: "Inbound Referral WF",
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfReferral }} Referral to {{ serviceLine }}",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "Referral",
  },
  [Classification.DME_ORDER]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.DME_ORDER,
    displayName: getClassificationDisplay(Classification.DME_ORDER, true),
    assignedTo: "USER, CPAP",
    folder: "SLEEP > DME",
    workflowType: "DME Order WF",
    inputDate: "Date Received",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateReceived }} DME Order",
    instructions: [
      "Based whether they have the required visit:",
      "CMN: Yes OR upcoming scheduled? Then",
      "Name document: YYYY.MM.DD CMN - last visit on YYYY.MM.DD",
      "Assign document to: User,CPAP",
      "Add to doc comments: Ready for signature.",
      "CMN: No appt in past 12 months? Then",
      "Name document: YYYY.MM.DD CMN - new visit needed",
      "Mark as reviewed",
      "Tel Enc to user, sleep center",
      "Patient order for CPAP/PAP received on YYYY.MM.DD. They do not have the required completed sleep visit in the [last 12 months/upcoming 90 days]. Please schedule them.",
      "",
      "Set Up:",
      "Name document: YYYY.MM.DD Setup",
      "Assign document to: User,CPAP",
      "",
      "**If no appt tel enc to user,sleep center",
      "Patient order for CPAP/PAP received on YYYY.MM.DD. They do not have the required completed sleep visit in the [last 12 months/upcoming 90 days]. Please schedule them",
      "",
    ],
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "DME",
  },
  [Classification.PROCEDURE_SLEEP]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.PROCEDURE_SLEEP,
    displayName: getClassificationDisplay(Classification.PROCEDURE_SLEEP, true),
    assignedTo: "USER, SLEEP RESULTS",
    folder: "Sleep Study",
    workflowType: "Procedure Sleep WF",
    inputDate: "Date of Event",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfEvent }} {{ studyType }} {{ isSigned }}",
    instructions: [
      "Document label: {{ dateOfEvent }} {{ studyType }} {{ isSigned }}",
      "",
      "Upload the Document to folder Sleep Study and assign to User, Sleep Results.",
      "",
      "In the Description add:",
      "If appointment scheduled:",
      "\t{{ ahi }} AHI - Results appointment scheduled MM/DD/YY",
      "",
      "If appointment needed:",
      "\t{{ ahi }} AHI Results appointment needed",
    ],
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "SLEEP STUDY",
  },
  [Classification.PHARMACY_RELATED]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.PHARMACY_RELATED,
    displayName: getClassificationDisplay(Classification.PHARMACY_RELATED, true),
    assignedTo: "User, Triage",
    folder: null,
    workflowType: "Pharmacy Related WF",
    inputDate: "Date of Document",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfDocument }} Rx Related",
    instructions: [
      "Document label: {{ dateOfDocument }} Rx Related",
      "",
      "Upload the Document to Patient and assign to based on:",
      "",
      "if Keneally: Kara Williams (PA)",
      "",
      "if allergy: User,Allergy",
      "",
      "if Kurtzman or Kekar: SUB Sanchez,Rafaela",
      "",
      "otherwise: User,Triage",
    ],
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "AUTHORIZATION > MEDICATION",
  },
  [Classification.LAB_RESULTS]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.LAB_RESULTS,
    displayName: getClassificationDisplay(Classification.LAB_RESULTS, true),
    assignedTo: "User, Triage",
    folder: "Labs",
    workflowType: "Standard",
    inputDate: "Date of Lab Results",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfLabResults }} Lab Results",
    instructions: [
      "Upload the Document to Patient and Assign to:",
      "",
      "if Provider = Kurtzman or Kekar: SUB Sanchez,Rafaela",
      "",
      "if Provider = Michael Friedman: User,Triage",
      "",
      "else assign to Provider",
      "",
      "Upload to folder: Labs",
    ],
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "LAB RESULTS",
  },
  [Classification.IMAGING_RESULTS]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.IMAGING_RESULTS,
    displayName: getClassificationDisplay(Classification.IMAGING_RESULTS, true),
    assignedTo: "User, Triage",
    folder: "x-ray",
    workflowType: "Standard",
    inputDate: "Date of Imaging Results",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfImagingResults }} {{ studyType }} Results",
    instructions: [
      "Upload the Document to Patient and Assign to:",
      "",
      "if Provider = Kurtzman or Kekar: SUB Sanchez,Rafaela",
      "",
      "if Provider = Michael Friedman: Michael Friedman",
      "",
      "else assign to Provider",
      "",
      "Upload to folder: X-Ray",
    ],
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "X-Ray Results",
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.PRIOR_AUTHORIZATION,
    displayName: getClassificationDisplay(Classification.PRIOR_AUTHORIZATION, true),
    assignedTo: null,
    folder: "Authorization",
    workflowType: "Prior Authorization WF",
    inputDate: "Date Received",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateReceived }} Prior Authorization",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: "AUTHORIZATION",
  },
  [Classification.ADMIN_LEAD_FORM]: {
    group: ConfigSubdomain.ENT_PARTNERS,
    classification: Classification.ADMIN_LEAD_FORM,
    displayName: getClassificationDisplay(Classification.ADMIN_LEAD_FORM, true),
    assignedTo: null,
    folder: null,
    workflowType: "Lead Form WF",
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
    folderMapping: null,
  },
};
